/**
 * Sonner Toast Component
 * 
 * Modern toast implementation using Sonner library with shadcn alert-style design,
 * color-coded text, and lucide icons for each toast type.
 */

import React from "react"
import { Toaster as Sonner, toast } from "sonner"
import { X } from "lucide-react"

type ToasterProps = React.ComponentProps<typeof Sonner>

// Custom close button component
const CustomCloseButton = ({ toastId }: { toastId: string | number }) => {
  return (
    <button
      onClick={() => toast.dismiss(toastId)}
      className="absolute right-2 top-2 border-0 bg-transparent p-1 text-foreground/50 hover:text-foreground rounded-sm h-6 w-6 hover:bg-accent transition-colors focus:outline-none focus:ring-1 focus:ring-ring flex items-center justify-center"
      aria-label="Close toast"
    >
      <X className="h-4 w-4" />
    </button>
  )
}

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      position="top-right"
      theme="light"
      closeButton={false}
      richColors
      {...props}
    />
  )
}

export { Toaster, CustomCloseButton }